// extracted by mini-css-extract-plugin
export default {"control_wrapper":"PlayerControl_control_wrapper__4cyD8","play_button":"PlayerControl_play_button__ykC++"};